import React, { useContext } from "react";
import { ProcessContainer } from "./Process.style";
import ProcessCard from "./ProcessCard/ProcessCard";
//import PropTypes from "prop-types";
import { ColorModeContext } from "context/ColorModeContext";
import { useTranslation } from "react-i18next";
import { ReactComponent as Image1 } from "../../../assets/images/svg/discovery.svg";
import { ReactComponent as Image2 } from "../../../assets/images/svg/development.svg";
import { ReactComponent as Image3 } from "../../../assets/images/svg/handshake.svg";
import { ReactComponent as Image4 } from "../../../assets/images/svg/chart-alt-fill.svg";
import useDevice from "hooks/useDevice";

const Process = () => {
  const { t } = useTranslation();
  const { theme } = useContext(ColorModeContext);
  const { isDesktop } = useDevice();

  const array = [
    {
      header: t("howWeCanHelpPage.paragraf1.items.item1.header"),
      image: <Image1 />,
      text: t("howWeCanHelpPage.paragraf1.items.item1.text"),
      badges: t("howWeCanHelpPage.paragraf1.items.item1.badges", {
        returnObjects: true,
      }),
      ...(isDesktop ? {} : { arrowLenght: 32 }),
      dashArray: isDesktop ? "9 13.5" : "3 7.5",
      color: theme?.colors?.primary,
    },
    {
      header: t("howWeCanHelpPage.paragraf1.items.item2.header"),
      image: <Image2 />,
      text: t("howWeCanHelpPage.paragraf1.items.item2.text"),
      badges: t("howWeCanHelpPage.paragraf1.items.item2.badges", {
        returnObjects: true,
      }),
      ...(isDesktop ? {} : { arrowLenght: 32 }),
      dashArray: isDesktop ? "9 13.5" : "3 7.5",
      color: theme?.colors?.thertiary,
    },
    {
      header: t("howWeCanHelpPage.paragraf1.items.item3.header"),
      image: <Image3 />,
      text: t("howWeCanHelpPage.paragraf1.items.item3.text"),
      badges: t("howWeCanHelpPage.paragraf1.items.item3.badges", {
        returnObjects: true,
      }),
      ...(isDesktop ? {} : { arrowLenght: 32 }),
      dashArray: isDesktop ? "9 13.5" : "3 7.5",
      color: theme?.colors?.secondaryOpaque,
    },
    {
      header: t("howWeCanHelpPage.paragraf1.items.item4.header"),
      image: <Image4 />,
      text: t("howWeCanHelpPage.paragraf1.items.item4.text"),
      badges: t("howWeCanHelpPage.paragraf1.items.item4.badges", {
        returnObjects: true,
      }),
      color: theme?.colors?.softBlue,
      arrowLenght: isDesktop ? "160" : "32",
      dashArray: isDesktop ? "9 13.5" : "3 7.5",
      showArrowhead: !isDesktop,
    },
  ];
  return (
    <ProcessContainer>
      {isDesktop && (
      <ProcessCard color={theme?.colors?.softBlue} arrowLenght={"40"} />
    )}
      {array.map((item, index) => (
        <ProcessCard {...item} key={index} color={item.color} />
      ))}
    </ProcessContainer>
  );
};

export default Process;
